export const GET_COMPANIES = 'GET_COMPANIES';
export const SET_EDITING_COMPANY = 'SET_EDITING_COMPANY';
export const ADD_COMPANY = 'ADD_COMPANY';
export const UPDATE_COMPANY = 'UPDATE_COMPANY';
export const DELETE_COMPANY = 'DELETE_COMPANY';
export const MODIFY_COMPANY = 'MODIFY_COMPANY';
export const TOGGLE_COMPANY = 'TOGGLE_COMPANY';
export const SET_CURRENT_COMPANY_ID = 'SET_CURRENT_COMPANY_ID';



// WEBPACK FOOTER //
// src/modules/secured/modules/companies/constants/companies_constants.js